import Context from "containers/UMS/Users/Context"
import { useContext } from "react"
import { useMutation } from "react-query"
import { mergeUsers } from "utils/requests"
// helpers
import get from 'lodash/get'
import { message } from "antd"
import useLogAction from "hooks/useLogAction"

const useMergeUSer = ({ userToMerge }) => {
  const { logAction } = useLogAction()
  const {
    queryHandler: { data: dataQuery },
    states: { selectedUser },
    actions: { onClose, setSelectedUser, setDirtyBit }
  } = useContext(Context)

  const handleClose = () => {
    onClose()
    setSelectedUser(null)
  }

  const { mutate, isLoading } = useMutation({
    mutationKey: 'mergeUsers',
    mutationFn: mergeUsers,
    onSuccess: ({ data }) => {
      const dataU = get(dataQuery, 'data', [])
      const user = dataU.find(({ identity_uuid }) => selectedUser === identity_uuid)

      logAction({
        event: "AIRFIND_USER", action: "UPDATE", metadata: {
          actionType: "transferAirfindUserInfo",
          userInfo: {
            uuid: userToMerge?.identity_uuid,
            firstname: userToMerge?.identity_first_name,
            lastname: userToMerge?.identity_last_name,
            email: userToMerge?.identity_email,
            phone: userToMerge?.identity_phone,
            points: userToMerge?.identity_point_count
          },
          transferedUserInfo: {
            uuid: selectedUser,
            firstname: user?.identity_first_name,
            lastname: user?.identity_last_name,
            email: user?.identity_email,
            phone: user?.identity_phone,
            points: user?.identity_point_count
          }
        }
      })
      onClose()
      setSelectedUser('')
      setDirtyBit(true)
      message.success({
        type: 'success',
        content: 'Operación realizada con éxito'
      })
    },
    onError: (e) => {
      message.error({
        type: 'error',
        content: 'Ha ocurrido un error'
      })
    }
  })

  const onMerge = () => {
    const data = get(dataQuery, 'data', [])
    const user = data.find(({ identity_uuid }) => selectedUser === identity_uuid)

    mutate({ user, userToMerge })
  }

  return { onMerge, isLoading, handleClose }

}

export default useMergeUSer